import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Linkify from 'react-linkify';
import ReactPlayer from 'react-player';

import LightboxImage from 'modules/components/web/light-box-image';

class ChatSingleMessage extends React.Component {
  static propTypes = {
    message: PropTypes.object.isRequired,
    // clientData: PropTypes.object.isRequired,
    // isLast: PropTypes.bool.isRequired,
    trainerData: PropTypes.object.isRequired, // eslint-disable-line
    clientData: PropTypes.object.isRequired,
    showName: PropTypes.bool,
  };

  static defaultProps = {
    showName: true,
  };

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const isSelf =
      this.props.clientData.aspNetUserId === this.props.message.aspNetUserId;

    // console.devLog.info('Single message this.props...', this.props);
    const messageClasses = isSelf
      ? 'bg-white rounded p-2 mb-1 float-right'
      : 'bg-primary rounded p-2 mb-1';

    const displayImage = () => {
      if (this.props.message.imageUrl === null) {
        return null;
      }

      const imageUrl = this.props.message.imageUrl.includes('giphy')
        ? this.props.message.imageUrl
        : this.props.message.preSignedUrl;

      return (
        <div className="max200">
          <LightboxImage images={[imageUrl]} />
        </div>
      );
    };

    const displayVideo = () => {
      // console.devLog.info('Video message this.props:', this.props.message);
      if (this.props.message.videoUrl === null) {
        return null;
      }
      return (
        <div className="react-player-wrapper">
          <ReactPlayer
            url={this.props.message.videoPreSignedUrl}
            className="react-player-player"
            width="100%"
            height="100%"
            controls
            light
          />
        </div>
      );
    };
    return (
      <div
        className={`single-message-container position-relative p-2 ${
          isSelf ? 'align-self-end' : ''
        }`}
      >
        <div
          className={`d-flex align-items-center mb-2 ${
            isSelf ? 'justify-content-end' : 'justify-content-start'
          }`}
        >
          {this.props.showName && (
            <p className="font-weight-light mb-0 mr-2">
              {this.props.message.abbreviatedName}
            </p>
          )}
          <small className="font-weight-light text-muted">
            {moment
              .utc(this.props.message.sent)
              .local()
              .format('dddd, MMMM Do, h:mm a')}
          </small>
        </div>

        {/* We want to have any messages that are ourself float to the right */}
        <div className={`d-inline-flex flex-column ${messageClasses}`}>
          {displayImage()}
          {displayVideo()}
          <Linkify properties={{ target: '_blank' }}>
            <div
              className={`message-content word-break ml-2 mr-2 ${
                !isSelf ? 'text-white' : ''
              }`}
            >
              {this.props.message.body}
            </div>
          </Linkify>
        </div>
      </div>
    );
  }
}

export default ChatSingleMessage;
